var map = {
	"./arrow-down.svg": "Peom",
	"./arrow-up.svg": "P3Ow",
	"./lineChart1.svg": "jaDB",
	"./lineChart2.svg": "lAwY",
	"./lineChart3.svg": "jF+s",
	"./lineChart4.svg": "BHX7",
	"./lineChart5.svg": "abxl",
	"./lineChart6.svg": "2Gk/",
	"./lineChart_new1.svg": "0Z1w",
	"./lineChart_new10.svg": "YqNA",
	"./lineChart_new11.svg": "T2hw",
	"./lineChart_new12.svg": "LPlk",
	"./lineChart_new13.svg": "FlT6",
	"./lineChart_new2.svg": "9Kyb",
	"./lineChart_new3.svg": "Sz6E",
	"./lineChart_new4.svg": "dVq9",
	"./lineChart_new5.svg": "kXQF",
	"./lineChart_new6.svg": "xQUL",
	"./lineChart_new7.svg": "NSeq",
	"./lineChart_new8.svg": "YBp9",
	"./lineChart_new9.svg": "yBvs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 517